import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ReplicationService } from "../../services/replication.service";
import { isRunning } from "../../utils/is-running";

@Injectable()
export class StatusGuard implements CanActivate {
  constructor(private router: Router, private replicationService: ReplicationService) {}
  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const id = route.paramMap.get("instance-id");
    return this.replicationService.getStatus(id).pipe(
      map((status) => {
        if (isRunning(status)) {
          return true;
        }
        const errorMessage = "Cannot navigate to the requested page while the replication process is stopped. Please start the replication process.";
        this.router.navigate(["/", "error"], { queryParams: { detail: errorMessage } });
        return false;
      })
    );
  }
}
